// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2WVox","checkboxCol":"Table_checkboxCol__13QuC","emailCol":"Table_emailCol__AMQYO","actionCol":"Table_actionCol__1dhk_"};